var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHusd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32821)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#005FFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6404 8.21145C11.3913 8.09831 11.1209 8.03981 10.8473 8.03989H8.08146C7.82635 8.03989 7.5817 7.93855 7.40131 7.75817C7.22093 7.57778 7.11959 7.33312 7.11959 7.07802V3.76489H5.19696V8.03989C5.19696 8.5501 5.39964 9.03942 5.76041 9.40019C6.12119 9.76096 6.6105 9.96364 7.12071 9.96364H9.88596C10.1411 9.96364 10.3857 10.065 10.5661 10.2454C10.7465 10.4258 10.8478 10.6704 10.8478 10.9255V14.2386H12.771V9.96364C12.771 9.59379 12.6643 9.23178 12.4638 8.92101C12.2633 8.61023 11.9774 8.36388 11.6404 8.21145ZM5.26277 11.1393V14.3703H7.18652V13.0625C7.18637 12.5523 6.98363 12.0632 6.62287 11.7025C6.26211 11.3419 5.77289 11.1393 5.26277 11.1393ZM11.1825 3.89764H10.7809V5.20546C10.7809 5.71567 10.9836 6.20498 11.3444 6.56575C11.7051 6.92652 12.1944 7.1292 12.7046 7.1292V3.89708L11.1825 3.89764Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32821"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHusd);
export default __webpack_public_path__ + "static/media/husd.6c2faf366b1ff5fcd2d7f18c1515e352.svg";
export { ForwardRef as ReactComponent };